const en = {
  //Header
  logoDescription: "Concept hookah club",

  //Menu
  home: "Home",
  menu: "Menu",
  reservation: "Reservation",
  faq: "FAQ",

  //Profile
  firstNameLabel: "Name",
  firstNamePlaceholder: "Your name",
  nicknameLabel: "Nickname",
  phoneLabel: "Phone number",
  phonePlaceholder: "+7 (___) ___-__-__",
  languageLabel: "Language",
  save: "Save",
  saving: "Save",
  saved: "Saved",
  language: "Interface language",
  visitHistoryTitle: "Visit history",
  visitHistoryLoading: "Loading history...",
  visitHistoryEmpty: "No visits yet.",
  visitHistoryError: "Failed to load history",
  visitTime: "Time",
  visitGuests: "Guests",
  visitDuration: "Duration",
  visitHoursShort: "h",
  visitMinutesShort: "min",

  //Home
  details: "Details",
  comingSoon: "coming soon",

  reserveTitle: "Book",
  reserveSubtitle: "now",

  menuTitle: "Menu",

  residence: "Residence",
  parking: "Parking",
  spaces: "Rooms",

  albumsTitle: "Photo albums",
  albumsSubtitle: "and moments",

  contactsTitle: "Contacts",
  contactsSubtitle: "and info",

  writeTitle: "Message",
  writeSubtitle: "the director",

  artifactsTitle: "Artifacts",
  cateringTitle: "Catering",
  merchTitle: "Merch",

  altMenu: "Menu",

  hookahLunch: "Hookah Lunch",
  vinylRoom: "Vinyl Room",
  radiolaRoom: "Radiola Room",
  veranda: "Veranda",
  studio54: "STUDIO 54",

  //Reservation
  title: "Reservation",

  bookingNameLabel: "Name for the booking",
  bookingNameRequired: "Enter a name",
  bookingNameInvalidError: "Enter a name",
  bookingNameFormatError: "Letters only",
  bookingNamePlaceholder: "Example: Ivan",

  phoneLabelReservation: "Phone number",
  phoneRequired: "Enter a phone number",

  dateLabel: "Select a date",
  dateFormatError: "Format DD.MM.YYYY",
  dateInvalidError: "Invalid date",
  dateClosedError: "Closed day",

  guestsLabel: "Number of guests",
  guestsRequired: "Enter number of guests",
  guestsPlaceholder: "Example: 3",
  guestsRangeError: "1 to 999 guests",

  timeLabel: "Arrival time",
  timeRequired: "Enter arrival time",
  timePlaceholderPrefix: "Example:",
  timeFormatError: "Format HH:MM",
  timeInvalidError: "Invalid time",
  timeNotWorkingError: "Outside working hours",

  durationLabel: "Duration",
  durationRequired: "Select duration",
  durationDefaultError: "1 to 24 hours",
  durationSecretError: "1 to 10 hours",
  durationStepError: "30-minute steps",

  duration_1h: "1 hour",
  duration_1_5h: "1.5 hours",
  duration_2h: "2 hours",
  duration_2_5h: "2.5 hours",
  duration_3h: "3 hours",
  duration_3_5h: "3.5 hours",
  duration_4plus: "4+ hours",

  roomLabel: "Room",
  roomPlaceholder: "Room",

  commentLabel: "Additional comment",
  commentPlaceholder: "Optional",
  commentHint: "(P.S. veranda reservations are strictly day-of, from 12:00)",

  submit: "Reserve",
  submitting: "Reserving...",
  success: "Request sent",
  submitError: "Failed to send request. Please try again later.",

  reservationHour: "hours",
  reservationHour2: "hours",

  //Parking
  parkingTitle: "Parking",
  guestParkingHeadline:
    "For your convenience, the Residence offers guest parking",
  howItWorksP1:
    "How it works: first book a table at the Residence in any way convenient for you (entry is available throughout the day of your reservation). If guests are joining you in their own cars, we will send you a link to register their vehicles on request (your companions only need to leave a name and a phone number).",
  howItWorksP2:
    "Then drive up to the “Dacha Gasheka” café (Dolgorukovskaya St., 31 bldg. 32) and turn right before their building. You will see two barriers (left and right). Use the left one.",
  barrierPhoneLabel:
    "When you are already at that barrier, simply call us using the dedicated number:",
  howItWorksP3: "That’s it: you can park in any available spot.",
  howItWorksP4: "Exit is also by calling the same number.",
  parkingWalkDistance:
    "The Residence is a three-minute walk from the parking lot.",
  parkingNotesTitle: "Two important notes:",
  parkingNote1:
    "1) Our parking is available only if you are heading to the Residence;",
  parkingNote2: "2) Parking is not available for car-sharing vehicles.",
  parkingThanks: "Thank you for your understanding! We look forward to seeing you!",
  buildRouteButton: "Build a route to the parking",
  yandexAriaLabel:
    "Route to Moscow, Dolgorukovskaya Street, 31 bldg. 32 in Yandex Maps",
  yandexTitle: "Route in Yandex Maps",
  parkingVideo: "Video on entering the parking lot:",

  //SendSms
  infoText:
    "Leave a message/suggestion/feedback. The manager will contact you soon.",
  placeholder: "Your message to the manager",
  alreadySentError: "Already sent. Please wait for a reply.",
  sendFailError: "Failed to send. Please try again.",
  sentStatus: "Message sent.",

  //Albums
  titleAlbums: "Photo Albums",
  titleAlbum: "Photo Album:",
  download: "Download",

  //Contacts
  ContactsTitle: "Contacts",
  mapTitle: "Yandex Map",

  workingHoursTitle: "Working hours:",
  workingHoursSunThu: "Sun–Thu 12:00–02:00",
  workingHoursFriSat: "Fri–Sat 12:00–04:00",
  workingHoursHolidayNote: "On public holidays, hours may change",

  addressTitle: "Address:",
  addressLine: "Moscow, Dolgorukovskaya St., 25, bldg. 1",
  entranceHint:
    "Entrance is directly from Dolgorukovskaya Street: a large wooden door and an intercom",
  entrancePhotoLink: "(photo for reference)",

  residencePhonesTitle: "Residence phone numbers:",

  ParkingTitle: "Parking",
  parkingHowToGetThere: "directions",
  parkingOpenBarrier: "Open the barrier:",

  wifiTitle: "Wi-Fi:",
  wifiNameLabel: "Network name:",
  wifiPasswordLabel: "Password:",

  socialNetworksTitle: "Social media:",

  writeToDirector: "Message the director",
  leaveReviewYandex: "Leave a review on Yandex",

  entrancePhotoAlt: "Entrance to the Residence",

  //Residence
  navResidence: "Musie Residence",
  navHistory: "Building history",
  navLegend: "The legend of Monsieur Le Kalyan",
  navRules: "Rules",

  videoUnsupported: "Your browser does not support HTML5 video.",

  residenceTitle: "Musie Residence",
  residenceP1:
    "A concept hookah club in Bauhaus style — with soul, history, and flair.",
  residenceP2:
    "We are sincere advocates of mid-20th-century interior design. More precisely, the Residence — in both aesthetics and mood — is the glorious era of the 70s and 80s. An eclectic vintage style with emphasized Bauhaus elements, and an abundance of incredibly comfortable and beautiful furniture, mainly of Scandinavian and Central European origin. All our furniture, lighting, and décor were collected, found, and brought over the course of 3.5 years, because we stand for authenticity — not replicas. At the same time, the Residence interior (like all Musie projects) is alive and in constant motion: it is periodically complemented and enriched with various curiosities.",
  residenceP3:
    "By the way, almost all the equipment you can see is analog — and fully working, not decorative. For example, our collection includes a classic “floppy” Macintosh, an ultra-rare Sharp 10P-35 boombox with a built-in TV, a powerful audio system with a Pioneer PL-780 turntable in the “Vinyl Room,” a carefully restored Rigonda radiola in the “Radiola Room,” several vintage Sanyo and Bang & Olufsen TVs, and more. As for what is “hidden” — the technical systems “inside the walls” — we selected and integrated them in line with today’s progress and the “smart” trend in electronics. Just the ventilation system alone is a huge engineering challenge: an extremely complex project handled by one of the best teams in Russia over five full months.",
  residenceP4:
    "We truly love living plants, so there are many of them in the Residence. They receive all necessary care; we even arranged a small greenhouse. Candle holders, classic board games, blankets and bowls for four-legged friends, fire extinguishers, and many other details were searched for and selected with maximum attention — literally every little thing.",
  residenceP5:
    "We are genuinely proud of how well the combination turned out: a mansion from the first half of the 19th century, furnished in the spirit of European homes from the second half of the 20th. The noble facade of one era in synergy with the elegance of another.",

  historyTitle: "Building history",
  historyP1:
    "“Musie Residence” is located in a fully restored 1821 mansion. It was built in 1821 and originally served as the main house of the estate of State Councillor Andrey Alexandrovich Petrovo-Solovovo. Later it changed owners several times, including Maria Alexandrovna Schiller, who (according to legend) knew Monsieur Le Kalyan. They met here more than once over a cup of tea and engaging conversation: Monsieur shared stories of his travels and often brought treats and various artifacts as friendly gifts.",
  historyP2:
    "From 2019 to 2022, our building underwent a long-overdue major reconstruction (after all, it had stood for 200 years). It preserved its historic appearance, but was significantly reinforced and reworked in technical and structural terms. Together with our numerous additional works (including restoration), it is now in excellent condition. We carefully preserved and restored the stucco, wooden doors and windows, and parquet floors in the large and small living rooms, and implemented a solid number of supportive and smart systems. In short, we did our best to keep its spirit and dignity, while also making it максимально technological, thoughtful, and comfortable — both for guests and for daily operations.",
  historyP3:
    "Inside, there is a truly special atmosphere, largely created by the architecture itself: stucco, high ceilings, fireplaces, parquet, and wooden windows and doors. Plenty of light, air, and an intelligent leitmotif.",
  historyP4:
    "There are living rooms, “secret” rooms, several small attraction-style rooms, a large summer veranda, and more. We have two floors, and they differ from each other in mood and spirit.",
  historyP5:
    "A separate point of pride is the arrangement of all work areas. Yes, only one of them is openly visible (the hookah masters’ work area), but we assure you that in all the others there is perfect order and excellent ergonomics.",
  historyP6:
    "Overall, it took a long time — carefully, thoroughly, and with great complexity — but look at the result! Everything for you, and for all of us together, friends!",

  legendTitle: "The legend of Monsieur Le Kalyan",
  legendP1:
    "It is not known for certain where and when Monsieur Le Kalyan lived. Some believe he was British and supplied Arab goods to the Old World. Others insist he was a Tibetan monk who practiced hookah smoking for inner harmony, experimented a lot with different packing methods, and lived for 150 years. Some claim he was French and personally acquainted with Napoleon — and that they sometimes even smoked hookah together while discussing plans for the world. There is also a hypothesis that Monsieur Le Kalyan lived in Russia, planned to introduce hookah fashion among the nobility, but the revolution got in the way.",
  legendP2:
    "In any case, there are no scientific works or historical studies confirming the existence of Monsieur Le Kalyan. He was not a great commander, conqueror, or Henry Ford. But he certainly was a true hookah fan who advocated that people learn to prepare it correctly and easily, and enjoy a bright aroma and thick smoke. We highly value such an impulse and will try to ensure his ideas continue to live.",

  rulesTitle: "Residence rules",
  rulesIntro:
    "To make your отдых as high-quality as possible and bring only positive emotions, we have a few rules:",
  rulesLi1: "We do not use obscene language.",
  rulesLi2: "The Residence is open exclusively to adult guests.",
  rulesLi3: "You may visit us only while sober.",
  rulesLi4: "We do not smoke cigarettes, IQOS, or e-cigarettes here.",
  rulesLi5: "Bringing your own drinks and alcohol is not allowed.",
  rulesOutro: "Thank you for understanding, and we wish you a wonderful time!",

  altInterior: "Interior",
  altTechnique: "Equipment",
  altPlantsDetails: "Plants and details",
  altResidenceHistory: "Residence history",
  altHistory: "History",

  //Rooms
  headerTitle: "Secret rooms and spaces",

  sacredRoomsTitle: "Secret rooms:",
  rentSpacesTitle: "Space rental:",

  vinylRoomName: "Vinyl Room",
  vinylRoomDesc:
    "A private room with a turntable, great sound, and a large vinyl record collection",

  radiolaRoomName: "Radiola Room",
  radiolaRoomDesc: "A private room with a radiola and a personal mini cinema",

  smallLivingRoomName: "Small Living Room",
  smallLivingRoomDesc: "Spacious, cozy, and beautiful — for up to 15 guests",

  discoHallName: "Disco Polaroid Hall",
  discoHallDesc:
    "A large 70s-style hall with Studio 54 references — for up to 30 guests",

  bigLivingRoomName: "Big Living Room",
  bigLivingRoomDesc:
    "Spacious, elegant, with a fireplace — for up to 20 guests",

  wholeResidenceName: "Entire Residence",
  wholeResidenceDesc:
    "Both floors + a veranda in warm season. An exclusive offer — premium pricing",

  detailsButton: "Learn more",

  faqSecretRoomsTitle: "FAQ about the secret rooms:",
  faqRentSpacesTitle: "FAQ about space rental:",

  faqPageRooms: {
    questions: [
      {
        id: 2,
        title: "Can we use the equipment in the “secret rooms” on our own?",
        answer:
          "Of course — you absolutely can (and should). Our team will show you what works and how to use it. Some devices also have custom, easy-to-follow instructions.",
      },
      {
        id: 3,
        title: "Is there a place where we can watch our own content?",
        answer:
          "Yes. In the “Radiola Room” you can watch any content on a great projector (movies, concerts, shows, YouTube, presentations, etc.) — in the highest quality and with excellent 5.1 sound.\n\nIn addition, both “secret rooms” have a vintage TV. We’ve integrated internet connectivity, so you can also watch any personal or desired content on them.\n\nOur team will show you everything and explain how to use it.",
      },
      {
        id: 4,
        title: "How loud can we play music in the “secret rooms”?",
        answer: "As loud as you like :)",
      },
      {
        id: 5,
        title: "Are the “secret rooms” suitable for business meetings?",
        answer:
          "More than. Both for business and for friendly meetings. In the “Radiola Room” you can also use the projector to show presentations or make video calls. In any case, you’ll be in separate rooms, which is often important for confidential conversations.\n\nThe “secret rooms” are also perfect for dates — or simply spending time alone (sometimes that’s exactly what you need).",
      },
      {
        id: 6,
        title:
          "Can we bring our own food and drinks, including alcohol, when renting a space?",
        answer:
          "You can bring food without any issues (for example, order catering). Drinks and alcohol, however, are only available from us and must be ordered from the menu. There are plenty of options for every taste.",
      },
      {
        id: 7,
        title: "For which rental options can we play our own music?",
        answer:
          "This is possible when renting the “Disco Polaroid” hall as a whole (one request: please keep it more or less aligned with our concept), and when renting the entire Residence — in that case, any music is allowed.",
      },
      {
        id: 8,
        title: "Is a deposit required when renting spaces?",
        answer:
          "It depends on the space. For the Small Living Room, no deposit is required. For the Big Living Room or the “Disco Polaroid” hall, the deposit is 20%. For renting the entire Residence, the deposit is 50% for a full-day rental and 30% for a part-day rental.",
      },
      {
        id: 9,
        title: "Can we invite your photographer for an event?",
        answer:
          "Yes, of course. We will connect you with Stepan, and you can discuss all details and pricing.",
      },
      {
        id: 10,
        title:
          "Is access to the veranda possible when renting the “Disco Polaroid” hall as a whole?",
        answer:
          "Unfortunately, no — we rent this hall only during the time when the veranda is not operating.",
      },
      {
        id: 11,
        title:
          "Is it possible to visit with a large group without renting a dedicated space?",
        answer:
          "It depends on how large your group is :) We have:\n- several large tables for 5–7 people;\n- “secret rooms”: “Vinyl Room” for 5–7 people and “Radiola Room” for 4–6 people; each costs 1500 RUB/hour regardless of time and day; no minimum spend;\n- combining two large tables in the “Disco Polaroid” hall for 8–12 people without renting the hall, but with a minimum spend:\n6000 RUB/hour (Mon–Fri 12:00–19:00, Mon–Thu & Sun 00:00–02:00, Fri–Sat 01:00–04:00, Sat–Sun 12:00–14:00)\nand\n9000 RUB/hour (Mon–Thu 19:00–00:00, Fri 19:00–01:00, Sat 14:00–01:00, Sun 14:00–00:00);\n- two table-combining options on the veranda: 6–8 guests without rental and without minimum spend + 9–12 guests without rental but with a minimum spend:\n7000 RUB/hour (Mon–Fri 12:00–19:00, Mon–Thu & Sun 00:00–02:00, Fri–Sat 01:00–04:00, Sat–Sun 12:00–14:00)\nand\n10000 RUB/hour (Mon–Thu 19:00–00:00, Fri 19:00–01:00, Sat 14:00–01:00, Sun 14:00–00:00).\n\nFor groups of 8+ guests, a 10% service charge applies.",
      },
      {
        id: 12,
        title:
          "Can we additionally decorate the rented space to match the event theme?",
        answer:
          "Yes, it’s possible. A “light” option is available when renting the Small Living Room or Big Living Room. A more “advanced” option is possible when renting the “Disco Polaroid” hall as a whole. Serious, substantial changes to the usual interior are only possible when renting the entire Residence.",
      },
      {
        id: 13,
        title:
          "Can we pay by bank transfer as a legal entity and sign a rental agreement?",
        answer:
          "Yes — both options are available, whichever is more convenient for you.",
      },
    ],
  },

  //FAQ
  faqPage: {
    title: "FAQ",
    questions: [
      {
        id: 8,
        title: "Can I come with a dog?",
        answer: `We love dogs and we’re happy to welcome them at the Residence with you. We provide water bowls and special comfy waterproof blankets.

Our main goal is for everyone to feel comfortable — all guests, without exception. Therefore, we have a few simple rules:

1) We love all breeds, but unfortunately we can only host small dogs (up to 40 cm at the withers);

2) We expect small dogs to be calm and well-behaved: no loud barking, and staying close to their owner;

3) We have waterproof blankets, but muddy paws are still an issue. Just in case, we always have special alcohol-free, hypoallergenic dog wipes;

4) We don’t have a dedicated dog toilet area, so please take your dog for a good walk before visiting.

Thank you for understanding — with love to our smaller (and bigger) friends!`,
      },
      {
        id: 9,
        title: "Is it convenient to work here during the day?",
        answer: `Absolutely! During daytime it’s comfortable to work with a laptop: stable internet, calm atmosphere, cozy tables, and power outlets at each table.

On weekdays many guests come specifically to work — we also have laptop side tables, and can bring one to you on request.

Also on weekdays from 12:00 to 17:00 we have a hookah lunch offer (classic hookahs for 2400 RUB).`,
      },
      {
        id: 10,
        title: "Can I bring my own drinks or food?",
        answer:
          "Unfortunately, bringing drinks (including alcohol) is not allowed. You may bring food, or order it via any delivery service. Please choose dishes without a strong smell so it doesn’t disturb guests nearby. Thanks for understanding!",
      },
      {
        id: 11,
        title: "Which documents are accepted to confirm 18+?",
        answer: `Documents that confirm age:

- Russian internal passport.
- Russian international passport.
- Temporary identity document (RF).
- Seaman’s passport.
- Diplomatic passport (RF).
- Service passport (RF).
- Military ID / serviceman identity card.
- Diplomatic/service/regular foreign passport (for foreign citizens).
- Residence permit (for stateless persons in RF).
- Temporary residence permit (for stateless persons in RF).
- Refugee certificate.
- Certificate of temporary asylum in RF.
- Driver’s license.

Documents that do NOT confirm age:

- Any documents shown inside the Gosuslugi app.
- Student ID.
- Copies of documents or photos of documents.`,
      },
      {
        id: 12,
        title: "Do you have PlayStation or Xbox?",
        answer: `No, we don’t have game consoles. But we do have an amazing vinyl record player in the “Vinyl Room”, a radiola and a modern projector in the “Radiola Room”, plus vintage TVs with carefully selected 20th-century content.

In the small living room there’s also a little attraction room with a large arcade machine available for all guests.`,
      },
      {
        id: 13,
        title: "Can I come with a minor?",
        answer:
          "No — even if the minor is accompanied by parents, siblings, or legal guardians. The Residence is strictly 18+.",
      },
      {
        id: 14,
        title: "Can I vape / use IQOS, etc.?",
        answer:
          "No. Vapes, heated tobacco sticks and similar devices are not allowed — only hookah 🙂",
      },
      {
        id: 15,
        title: "Can I relax without ordering a hookah?",
        answer: `“Musie Residence” is a specialized hookah club. Visiting this type of venue generally implies hookah. Sometimes only part of a table smokes hookah — that’s totally fine, and we have a high-quality ventilation system.

Without hookah you can relax in any of our private rooms (“Radiola Room” or “Vinyl Room”), but in that case the rental price is 3000 RUB/hour.`,
      },
      {
        id: 16,
        title: "Can I do a photoshoot or professional filming?",
        answer: ({ Link }) => (
          <>
            You can take photos and videos at the Residence. The main thing is
            not to disturb other guests.
            {"\n\n"}
            Professional shoots depend on the format. If you plan a photoshoot
            or professional video filming, you can{" "}
            <Link
              to="/send-sms"
              style={{
                color: "#366091",
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              message the director
            </Link>{" "}
            in the appropriate section in the bot — he’ll clarify details based
            on your request.
          </>
        ),
      },
      {
        id: 17,
        title: "Can we play poker here?",
        answer:
          "No — unfortunately we have to answer clearly: poker is not allowed in any form, even without bets.",
      },
    ],
  },

  //Rooms
  roomNames: {
    vinil: "Vinyl Room",
    radiola: "Radiola Room",
    livingrm: "Small Living Room (entire)",
    disco: "Discopolaroid Hall (entire)",
    bigliving: "Big Living Room (entire)",
    residence: "Entire Residence",
  },

  roomNames2: {
    vinil: "the Vinyl Room",
    radiola: "the Radiola Room",
    livingrm: "the Small Living Room (entire)",
    disco: "the Discopolaroid Hall (entire)",
    bigliving: "the Big Living Room (entire)",
    residence: "the Entire Residence",
  },

  ariaPrevPhoto: "Previous photo",
  ariaNextPhoto: "Next photo",

  pricePerHourLabel: "Price per hour",
  pricePerHourValue: "1500 RUB",

  wifiLabel: "Wi-Fi:",
  passwordLabel: "Password:",

  sendRequestPrefix: "Send a request for:",

  bookingNameError: "Enter a name",
  phoneError: "Enter a phone number",

  guestsOnlyDigitsError: "Digits only",
  guestsError: "Enter number of guests",

  timeError: "Enter arrival time",

  durationErrorText: "1 to 24 hours",
  durationError: "Select duration",
  durationPlaceholder: "Enter duration (in hours)",

  descriptionRequiredError: "Add a description",
  descriptionLabel: "Additional comment",
  descriptionPlaceholder: "Enter important event details",

  sending: "Sending...",
  sent: "Request sent",
  send: "Send",

  bookPrefix: "Book",

  vinil: [
    <>
      <b>“Vinyl Room”</b> is a private room where you can travel through time
      and space — wrapped in seclusion, great sound, pure analog vibe, the soft
      crackle of a needle on vinyl, and the visual noise of VHS tapes.
      <br />
      <br />
      Here you’ll find a{" "}
      <b>
        vintage Pioneer PL-780 turntable paired with the legendary Japanese
        Marantz SR4400 amplifier
      </b>
      . Vinyl playback is fully automatic — even with a repeat function. And it
      sounds fantastic. On top of that, the “Vinyl Room” has{" "}
      <b>full, high-quality soundproofing on every wall</b>, so you don’t have
      to hold back on the volume :)
      <br />
      <br />
      If you’re more in the mood for a tactile “press play” experience — movies,
      series, TV shows, or music videos — you’ll love the Danish 90s classic
      setup: a <b>Bang &amp; Olufsen TV and VCR</b>, which was (and still is) a
      real rarity.
      <br />
      <br />
      When you visit the “Vinyl Room” for the first time, we’ll definitely show
      you hands-on how to turn everything on and how to use the equipment.
      <br />
      <br />
      For both audio and video, the “Vinyl Room” gives you access to a{" "}
      <b>luxury vinyl collection</b> (around 300 records — from classics to
      modern pop), plus{" "}
      <b>
        VHS tapes and a console with the best visual content from the second
        half of the 20th century
      </b>
      . And if you want, you can play absolutely anything on this TV — it’s
      connected to a dedicated network :)
      <br />
      <br />
      <b>
        The “Vinyl Room” comfortably fits 4–5 people; 6–7 people will be a bit
        tighter, but still quite comfortable.
      </b>
    </>,
  ],

  radiola: [
    <>
      We find a special kind of comfort and pleasure in the tactile, analog
      nature of vintage equipment.
      <br />
      <br />
      <b>“Radiola Room”</b> is a private room that delivers this feeling in
      several ways at once:
      <br />
      <br />
      <b>When it comes to analog sound</b>, the golden era of radiolas was the
      mid-20th century, when the large tube-radio cabinets could easily be
      combined with vinyl turntables.
      <br />
      <br />
      That’s why our <b>carefully restored Rigonda radiola</b> is a small
      tribute to that time — and a key element of this “secret room,” which
      actually gave the room its name. The unit is fully functional and can fill
      the space with music from small records (we prepared a compact
      collection). And it also looks amazing on its own — a technical décor
      object that sets the mood.
      <br />
      <br />
      <b>For visual enjoyment, you’ll find:</b>
      <br />
      <br />
      First, a classic Sanyo TV — a beautifully preserved piece from one of the
      three “giants” of Japanese manufacturers of its era. As with the TV in the
      “Vinyl Room,” and thanks to a special set-top box, we tried to recreate
      the feel of vintage television — with ads, films, shows, and music videos
      of those years. It’s genuinely fascinating to watch. And if you want, you
      can play anything you like on this TV as well — it’s connected to a
      dedicated network :)
      <br />
      <br />
      Second, the “Radiola Room” also perfectly fits a modern piece of tech: an{" "}
      <b>ultra-short-throw laser projector</b>. You can watch literally anything
      on it — from movies and concerts to series, YouTube, and work
      presentations. The picture is excellent even on a sunny day, and
      everything is backed by a well-tuned 5.1 sound system. In short, it’s your{" "}
      <b>personal, compact, fully functional cinema</b> :)
      <br />
      <br />
      The final touch for maximum comfort is an incredible{" "}
      <b>
        Danish “Stressless” sofa from the 80s with individual backrest angle
        adjustment
      </b>
      , and each section adjusts separately.
      <br />
      <br />
      This feeling is hard to describe — better to experience it yourself :)
      <br />
      <br />
      <b>
        The “Radiola Room” comfortably fits 4 people; 5–6 people will be a bit
        tighter, but still quite comfortable.
      </b>
    </>,
  ],

  livingrm: [
    <>
      <b>“Small Living Room”</b> is a guest favorite: a hall with a fireplace, a
      piano, and large windows that let in beautiful sunlight during the day.
      <br />
      <br />
      By default, there are 2 tables here, but you can rent the entire Small
      Living Room: we’ll bring additional furniture, and we can also arrange 2–3
      high cocktail tables for a buffet. The photos show an example layout.
      <br />
      <br />
      We are <b>always happy to take a pre-order</b> from our menu in advance,
      so everything is ready and waiting for you when you arrive.
      <br />
      <br />
      You may bring your own food (for example, catering or delivery), but you
      may not bring your own alcohol or any other drinks.
      <br />
      <br />
      <b>
        The optimal capacity of the Small Living Room when rented as a whole is
        up to 15 people.
      </b>
      <span style={{ display: "block", height: "20px" }} />
    </>,
    <>
      <b>The total cost consists of the rental fee plus a minimum spend:</b>
    </>,
    <>
      - The rental fee is 1500 RUB/hour on any day and at any time;
      <br />
      - The minimum spend is calculated as follows:
      <br />
      <br />
      <i>Mon–Thu, 12:00–19:00 and 00:00–02:00 — 7000 RUB/hour;</i>
      <br />
      <i>Mon–Thu, 19:00–00:00 — 10000 RUB/hour;</i>
      <br />
      <br />
      <i>Fri, 12:00–19:00 — 7000 RUB/hour;</i>
      <br />
      <i>Fri, 19:00–01:00 — 15000 RUB/hour;</i>
      <br />
      <i>Fri, 01:00–04:00 — 9000 RUB/hour;</i>
      <br />
      <br />
      <i>Sat, 12:00–18:00 and 01:00–04:00 — 9000 RUB/hour;</i>
      <br />
      <i>Sat, 18:00–01:00 — 15000 RUB/hour;</i>
      <br />
      <br />
      <i>Sun, 12:00–18:00 and 00:00–02:00 — 8000 RUB/hour;</i>
      <br />
      <i>Sun, 18:00–00:00 — 12000 RUB/hour.</i>
      <br />
      <br />
      A 10% service charge applies to the minimum spend (and any bill amount
      above the minimum spend).
      <br />
      <br />
      No prepayment is required.
    </>,
  ],

  disco: [
    <>
      <b>“Discopolaroid” Hall</b> is a large space in the spirit of the 70s–80s,
      with a clear bow toward the Studio 54 era — the club life of those, so to
      speak, golden times.
      <br />
      <br />
      There’s an impressive mirrored disco ball (you can turn on rotation) and
      plenty of matching elements. Disco Stu in a mirrored frame is a particular
      favorite :) The mood is also shaped by our custom hookah “Studio 54,”
      which has long been an internal star of the Residence. On shelves, racks,
      and windowsills you’ll also find a rather unique collection of working
      Polaroid cameras — we love them for their analog charm and the special
      magic of the photos they produce. And there’s a small greenhouse too (also
      with a disco motif!).
      <br />
      <br />
      Normally, “Discopolaroid” has 8 tables, but you can rent the entire hall:
      we will combine tables, bring additional furniture if needed, set up a
      small dance floor (if required), and we can also provide good concert
      speakers with a subwoofer and a DJ booth (no mixer/controller included).
      The photos show an example layout.
      <br />
      <br />
      We are <b>always happy to take a pre-order</b> from our menu in advance,
      so everything is ready and waiting for you when you arrive.
      <br />
      <br />
      You may bring your own food (for example, catering or delivery), but you
      may not bring your own alcohol or any other drinks.
      <br />
      <br />
      <b>
        The optimal capacity of the “Discopolaroid” Hall when rented as a whole
        is up to 30 people.
      </b>
      <span style={{ display: "block", height: "20px" }} />
    </>,
    <>
      <b>The total cost consists of the rental fee plus a minimum spend:</b>
    </>,
    <>
      - Rental fee is calculated as follows:
      <br />
      <br />
      <i>Mon–Thu, 12:00–18:00 and 00:00–02:00 — 10000 RUB/hour;</i>
      <br />
      <i>Mon–Wed, 18:00–00:00 — 15000 RUB/hour;</i>
      <br />
      <i>Thu, 18:00–00:00 — 20000 RUB/hour;</i>
      <br />
      <br />
      <i>Fri, 12:00–18:00 — 15000 RUB/hour;</i>
      <br />
      <i>Fri, 18:00–01:00 — 30000 RUB/hour;</i>
      <br />
      <i>Fri, 01:00–04:00 — 15000 RUB/hour;</i>
      <br />
      <br />
      <i>Sat, 12:00–17:00 and 01:00–04:00 — 15000 RUB/hour;</i>
      <br />
      <i>Sat, 17:00–01:00 — 30000 RUB/hour;</i>
      <br />
      <br />
      <i>Sun, 12:00–17:00 — 15000 RUB/hour;</i>
      <br />
      <i>Sun, 17:00–00:00 — 20000 RUB/hour;</i>
      <br />
      <i>Sun, 00:00–02:00 — 10000 RUB/hour.</i>
      <br />
      <br />
      - Minimum spend is calculated as follows:
      <br />
      <br />
      <i>Mon–Thu, 12:00–18:00 — 10000 RUB/hour;</i>
      <br />
      <i>Mon–Thu, 18:00–00:00 — 30000 RUB/hour;</i>
      <br />
      <i>Mon–Thu, 00:00–02:00 — 20000 RUB/hour;</i>
      <br />
      <br />
      <i>Fri, 12:00–18:00 — 15000 RUB/hour;</i>
      <br />
      <i>Fri, 18:00–01:00 — 40000 RUB/hour;</i>
      <br />
      <i>Fri, 01:00–04:00 — 25000 RUB/hour;</i>
      <br />
      <br />
      <i>Sat, 12:00–17:00 — 25000 RUB/hour;</i>
      <br />
      <i>Sat, 17:00–01:00 — 40000 RUB/hour;</i>
      <br />
      <i>Sat, 01:00–04:00 — 25000 RUB/hour;</i>
      <br />
      <br />
      <i>Sun, 12:00–17:00 and 00:00–02:00 — 25000 RUB/hour;</i>
      <br />
      <i>Sun, 17:00–00:00 — 40000 RUB/hour.</i>
      <br />
      <br />
      A 10% service charge applies to the minimum spend (and any bill amount
      above the minimum spend).
      <br />
      <br />
      Prepayment: 20%.
      <br />
      <br />
      It’s best to book at least one day before your desired date.
      <br />
      <br />
      <b>One important detail about renting “Discopolaroid” as a whole:</b> this
      option is available only during the period when our veranda is not
      operating (because access to the veranda goes through this hall). In other
      words, “Discopolaroid” is rented without veranda access.
    </>,
  ],

  bigliving: [
    <>
      <b>“Big Living Room”</b> is our main flagship hall. Restored stucco,
      wooden windows, parquet, a fireplace — everything is designed in the best
      Bauhaus traditions, with a sense of space and a special vintage mood.
      <br />
      <br />
      By default, there are 5 tables here, but you can rent the entire Big
      Living Room: we’ll bring additional furniture if needed, and we can also
      arrange 2–3 high cocktail tables for a buffet. The photos show an example
      layout.
      <br />
      <br />
      We are <b>always happy to take a pre-order</b> from our menu in advance,
      so everything is ready and waiting for you when you arrive.
      <br />
      <br />
      You may bring your own food (for example, catering or delivery), but you
      may not bring your own alcohol or any other drinks.
      <br />
      <br />
      <b>
        The optimal capacity of the Big Living Room when rented as a whole is up
        to 20 people.
      </b>
      <span style={{ display: "block", height: "20px" }} />
    </>,
    <>
      <b>The total cost consists of the rental fee plus a minimum spend:</b>
    </>,
    <>
      - Rental fee is calculated as follows:
      <br />
      <br />
      <i>Mon–Thu, 12:00–18:00 and 00:00–02:00 — 10000 RUB/hour;</i>
      <br />
      <i>Mon–Wed, 18:00–00:00 — 15000 RUB/hour;</i>
      <br />
      <i>Thu, 18:00–00:00 — 20000 RUB/hour;</i>
      <br />
      <br />
      <i>Fri, 12:00–18:00 — 10000 RUB/hour;</i>
      <br />
      <i>Fri, 18:00–01:00 — 25000 RUB/hour;</i>
      <br />
      <i>Fri, 01:00–04:00 — 15000 RUB/hour;</i>
      <br />
      <br />
      <i>Sat, 12:00–17:00 and 01:00–04:00 — 15000 RUB/hour;</i>
      <br />
      <i>Sat, 17:00–01:00 — 25000 RUB/hour;</i>
      <br />
      <br />
      <i>Sun, 12:00–17:00 — 15000 RUB/hour;</i>
      <br />
      <i>Sun, 17:00–00:00 — 20000 RUB/hour;</i>
      <br />
      <i>Sun, 00:00–02:00 — 10000 RUB/hour.</i>
      <br />
      <br />
      - Minimum spend is calculated as follows:
      <br />
      <br />
      <i>Mon–Thu, 12:00–18:00 — 10000 RUB/hour;</i>
      <br />
      <i>Mon–Thu, 18:00–00:00 — 20000 RUB/hour;</i>
      <br />
      <i>Mon–Thu, 00:00–02:00 — 15000 RUB/hour;</i>
      <br />
      <br />
      <i>Fri, 12:00–18:00 — 15000 RUB/hour;</i>
      <br />
      <i>Fri, 18:00–01:00 — 35000 RUB/hour;</i>
      <br />
      <i>Fri, 01:00–04:00 — 20000 RUB/hour;</i>
      <br />
      <br />
      <i>Sat, 12:00–17:00 — 15000 RUB/hour;</i>
      <br />
      <i>Sat, 17:00–01:00 — 40000 RUB/hour;</i>
      <br />
      <i>Sat, 01:00–04:00 — 20000 RUB/hour;</i>
      <br />
      <br />
      <i>Sun, 12:00–17:00 and 00:00–02:00 — 15000 RUB/hour;</i>
      <br />
      <i>Sun, 17:00–00:00 — 30000 RUB/hour.</i>
      <br />
      <br />
      A 10% service charge applies to the minimum spend (and any bill amount
      above the minimum spend).
      <br />
      <br />
      Prepayment: 20%.
      <br />
      <br />
      It’s best to book at least one day before your desired date.
    </>,
  ],

  Residence: [
    <>
      <b>The entire Residence</b> is a chance to immerse yourself in an
      atmosphere of coziness, vintage interiors, and creativity — with no
      strangers around.
      <br />
      <br />
      You’ll have both floors, all halls and “secret rooms,” the veranda (in the
      warm season), and complete freedom.{" "}
      <b>
        Corporate events, weddings, birthdays, themed events and parties, and
        presentations are all possible.
      </b>
      <br />
      <br />
      An exclusive offer for those who value privacy and want something special.
      Each full-Residence rental is discussed individually — taking into account
      all details, pre-orders, and other guest requests. You may bring your own
      food (for example, catering), but you may not bring your own alcohol or
      any other drinks.
      <br />
      <br />
      We can also help with DJs and performers, equipment rental (music,
      lighting, etc.), and services of a talented decorator, photographer, and
      videographer. If needed, we’ll share contacts of proven food catering
      teams. We also have extra furniture and buffet tables.
      <br />
      <br />
      <b>
        Capacity of the entire Residence when rented as a whole is up to 100
        people. With the veranda — up to 150 people.
      </b>{" "}
      Important: the veranda is available only in the warm season and can
      operate only until 23:00.
      <span style={{ display: "block", height: "20px" }} />
    </>,
    <>
      <b>
        The total cost consists of the rental fee plus a minimum spend (depends
        on the specific time and day of the week) and is calculated
        individually.
      </b>
      <br />
      <br />
      A 10% service charge applies to the minimum spend (and any bill amount
      above the minimum spend).
      <br />
      <br />
      When renting the entire Residence for a full day, a 10% discount applies.
      <br />
      <br />
      Prepayment: 50% for a full-day rental, 30% for a part-day rental.
      <br />
      <br />
      Booking is possible at least one week before your desired date.
    </>,
  ],
};

export default en;
